import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module.js';
import { ListWorkoutsComponent } from './list-workouts.component.js';
import { ViewOrEditWorkoutComponent } from './view-or-edit-workout.component.js';
import { WorkoutFormComponent } from './workout-form.component.js';
import { FormsModule } from '@angular/forms';
import { ExercisesModule } from '../exercises/exercises.module.js';
import { FormModule } from 'lib/ui/form/form.module.js';
import { SessionsModule } from "../sessions/sessions.module.js";

@NgModule({
    declarations: [ViewOrEditWorkoutComponent, ListWorkoutsComponent, WorkoutFormComponent],
    exports: [ViewOrEditWorkoutComponent, ListWorkoutsComponent, WorkoutFormComponent],
    imports: [CoreModule, FormModule, FormsModule, ExercisesModule, SessionsModule]
})
export class WorkoutsModule {}
